<template>
  <div id="video-editor">
    <div class="main-wrapper">
      <div class="block-title">
        <el-badge value="beta">
          <h2 class="title-name">天工AI创意编辑器</h2>
        </el-badge>
      </div>
      <div class="main">
        <ConfigForm @submit-finished="configFormSubmitFinished" class="config-form">
          <template #route-radio>
            <RouteRadio></RouteRadio>
          </template>
        </ConfigForm>
        <TaskPannel ref="taskPannelRef" class="task-wrapper"></TaskPannel>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import ConfigForm from './components/config-form/index.vue'
import TaskPannel from './components/task-pannel/index.vue'
import RouteRadio from './route-radio.vue'
const taskPannelRef = ref(null)

function configFormSubmitFinished() {
  taskPannelRef.value.onQuery()
}
</script>

<style scoped lang="scss">
@import 'styles/index.scss';

#video-editor {
  height: 100vh;
  margin-bottom: 0;
  overflow: auto;
  background-color: #fafafa;

  .main-wrapper {
    min-width: 1600px;
    padding: $gap;

    .block-title {
      display: flex;
      align-items: center;
      .title-name {
        font-size: 20px;
        font-weight: 600;
      }
    }

    .main {
      margin-top: $gap;
      display: flex;
      // align-items: center;

      .task-wrapper {
        flex: 1;
      }
    }
  }
}
</style>
